import { useNavigate } from 'react-router-dom'
import {
  AdCopyRouteBuilder,
  AdGroupRouteBuilder,
  AdTemplateRouteBuilder,
  CampaignRouteBuilder,
  CompanyRouteBuilder,
  PositionRouteBuilder,
  WebsiteRouteBuilder,
} from '../../pages/routeParams'
import { CompanyType } from '../../__generated__/graphql'

export type CompanyNavigationState = {
  openCreate?: 'campaign' | 'website'
}

export function useNavigation() {
  const navigate = useNavigate()

  return {
    goToCompany: (slug: string, type: CompanyType, state?: CompanyNavigationState) =>
      navigate(CompanyRouteBuilder(slug, type), state ? { state } : undefined),

    goToAdgroup: (slug: string, adgroupId: string) => navigate(AdGroupRouteBuilder(slug, adgroupId)),

    goToCampaign: (slug: string, campaignId: string) => navigate(CampaignRouteBuilder(slug, campaignId)),

    goToWebsite: (slug: string, websiteId: string) => navigate(WebsiteRouteBuilder(slug, websiteId)),

    goToPosition: (slug: string, positionId: string) => navigate(PositionRouteBuilder(slug, positionId)),

    goToAdcopy: (slug: string, adgroupId: string, adcopyId: string) =>
      navigate(AdCopyRouteBuilder(slug, adgroupId, adcopyId)),

    goToAdTemplate: (slug: string, positionId: string, adTemplateId: string) =>
      navigate(AdTemplateRouteBuilder(slug, positionId, adTemplateId)),
  }
}
